import { createRoot } from 'react-dom/client'
import { onError } from '@praxis/component-logging'
//import { reportWebVitals } from '@praxis/component-logging'
import App from './App'

window.onerror = onError

// This is currently sending metrics to Item Hub instead of our app.
// We'll want to figure out a different way of collecting these metrics so that
// we can specify where they're sent.
//reportWebVitals()

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
